import { useEffect, useState } from 'react'
import { AnimatePresence, motion, useScroll, useMotionValueEvent } from 'motion/react'
import { CALENDLY_URL } from './constants'
import { useLanguage } from '@/i18n/LanguageContext'

export default function StickyCta() {
  const { t } = useLanguage()
  const { scrollY } = useScroll()
  const [pastThreshold, setPastThreshold] = useState(false)
  const [footerVisible, setFooterVisible] = useState(false)

  useMotionValueEvent(scrollY, 'change', (y) => {
    setPastThreshold(y > 600)
  })

  useEffect(() => {
    const footer = document.querySelector('footer')
    if (!footer) return
    const observer = new IntersectionObserver(([entry]) =>
      setFooterVisible(entry.isIntersecting),
    )
    observer.observe(footer)
    return () => observer.disconnect()
  }, [])

  const visible = pastThreshold && !footerVisible

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 96, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 96, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 320, damping: 28 }}
          className="pointer-events-none fixed bottom-0 left-0 right-0 z-40 bg-gradient-to-t from-cream/95 via-cream/70 to-transparent px-4 pb-[calc(1rem+env(safe-area-inset-bottom))] pt-12 md:hidden"
        >
          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="pointer-events-auto block w-full whitespace-nowrap rounded-full bg-terracotta py-4 text-center text-base font-semibold text-cream shadow-lg shadow-terracotta/30"
          >
            {t.common.ctaLabel}
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
